<template>
	<form v-on:submit.prevent="validateBeforeSubmit">
		<ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="50000">{{ $t('textBtn.btnSearch') }}</ejs-progressbutton>
	</form>
</template>

<script>
import axios from 'axios'
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
Vue.use(ProgressButtonPlugin);

export default {
	name: "reports-form-access",
	props: ['tittle'],
	data() {
		return {
			spinSettings: { position: 'Right', width: 20 },
			disabledButton :false,
			responseReport: false,
		}
	},
	methods: {
		validateBeforeSubmit: function() {
			this.disabledButton = true;
         this.responseReport = false;
			this.$refs.progressBtn.enable;
			axios.post('/auth/reports/getReportsAccess').then(response => {
				this.responseReport = true;
				Vue.prototype.$eventHub.$emit('loadDataReports', this.$props.tittle , response.data);
			});
		},
		progress: function() {
            if(this.responseReport){
                this.$refs.progressBtn.stop();       
            }
        }
	}
}
</script>